import { updateOrderSnapshot } from '@/entities/order';
import { Alert, type AlertProps } from '@/shared/components/Alert';
import { DrawerBottomFixed, DrawerButton } from '@/shared/components/Drawer';
import { useAsyncFn } from '@/shared/lib/hooks';

interface OutdatedLoyaltyConditionsProps extends AlertProps {
    orderId: string;
    signature: string;
    storeSlug: string;
    refresh: () => Promise<unknown>;
}

export const OutdatedLoyaltyConditions = (props: OutdatedLoyaltyConditionsProps) => {
    const { orderId, refresh, signature, storeSlug, onClose } = props;

    const [{ loading }, onLoyaltyRefresh] = useAsyncFn(async () => {
        await updateOrderSnapshot({ order_id: orderId, signature, store_slug: storeSlug });
        await refresh();
        onClose?.();
    }, [signature, orderId]);

    return (
        <Alert
            {...props}
            title="Количество баллов было изменено"
            closable={false}
            button={
                <DrawerBottomFixed>
                    <DrawerButton isDisabled={loading} onClick={onLoyaltyRefresh}>
                        Обновить заказ
                    </DrawerButton>
                </DrawerBottomFixed>
            }
        />
    );
};
